module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABLElEQVRYR+3X7Q2CMBAG4Hsn0BF0MnUC3UDZwBFwM93ADWouAYN89I67kmJSfkJLH67t2wBa+YWV+6gAvTNUKlgq6K2At39Zg39bwRDClojORHRpPuIOoOp/ULYpDiHURHTogSoAt+69LMAJHLueAPZZgREcu14AdtmAAo5d+aZYgXsAOGbZJFYcYxffJB5cFKjNqVgQe3ES8N4EaddQAzhpTocUOAn4JqLNCEZEpsJZgdxvEpkSJwH5yLlGpnOATI0Td7FiwC9S0XY056T1LMaMYmA+9PkahGxncBNOrGA7gAIZK4QZpwZyQyPShZsFNCDduNnAGcgkOBNQgUyGMwMjyKQ4F7BBcpi38cKZ+PM/IWWc5rmYg5qXLNmmAL3VLRUsFfRWwNt/9WvwAwI9jSmBl+cwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/solution/yes.png
// module id = feVK
// module chunks = 1